// update with any new path patterns that need to be supported
// pages with propertyId parameter have propertyId preceded by 'properties/' or 'property/' in the url
const LISTING_ALIAS_PATH_PREFIX_DELIMETERS = ['properties/', 'property/'];

const getListingAliasFromPath = (path = '') => {
  let listingAlias = '';
  LISTING_ALIAS_PATH_PREFIX_DELIMETERS.every((delimeter: string) => {
    const pathParts = path.split(delimeter);
    const pathParts2 = pathParts[1]?.split(/[/?]/) || [];
    if (pathParts2[0]?.length > 0) {
      // found the listingAlias, no need to continue
      listingAlias = pathParts2[0];
      return false;
    }
    return true;
  });
  return listingAlias;
};

export { getListingAliasFromPath };
